<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      宝田一路站<br>
站点介绍<br>
宝田一路站位于前进二路和宝田一路交叉口，沿前进二路呈南北方向建设，为地下二层车站，地下一层为站厅层，地下二层为站台层，站台形式为岛式站台。车站周边现状以住宅和商业为主，兼有商业贸易、绿化等多种功能的综合居住区。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:39	23:35	12号线	4分钟	8分钟<br>
海上田园东	06:12	23:36	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	06:43	23:35	12号线	8分钟	8分钟<br>
海上田园东	06:14	23:36	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>

站点出口信息<br><br>
B出入口:<br>
前进二路西侧，流塘派出所<br><br>
C出入口:<br>
深圳登喜路国际大酒店<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名： 西乡综合执法队<br>
727，m250，M425<br><br>
C出入口:<br>
公交站名： 凤凰岗村<br>
610，606，605，M209，M330<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "shierhaoxian",
            title: "12号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>